/**
 * Shared /api/cases filters for Investigation list + Investigation pipeline Kanban.
 * Keep both screens on the same dataset so counts and rows match.
 *
 * Include legacy regulatory case types (SMR, SUSPICIOUS, UAR) until all rows are migrated to
 * case_type=INVESTIGATION (see docs/INVESTIGATION_LIFECYCLE_NUMBERING.md). Otherwise SMR demo
 * cases with status PENDING_REVIEW never appear and the SMR Draft column looks empty.
 */
export const INVESTIGATION_WORKSPACE_CASE_TYPES = 'INVESTIGATION,SMR,SUSPICIOUS,UAR'
export const INVESTIGATION_WORKSPACE_LIMIT = 200

export function buildInvestigationWorkspaceCasesQuery() {
  return new URLSearchParams({
    case_type: INVESTIGATION_WORKSPACE_CASE_TYPES,
    limit: String(INVESTIGATION_WORKSPACE_LIMIT),
  })
}
